import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import { isTokenValid } from "utils/helpers/auth";

export interface Profile {
  contact: string;
  firstName: string;
  lastName: string;
  email?: string;
  siret?: string;
  idGA?: string;
  id?: number;
  isInternal?: boolean;
}

export interface AuthSliceState {
  isAuth: boolean;
  profile: Profile;
}

const initialState: AuthSliceState = {
  isAuth: isTokenValid(),
  profile: { contact: "", firstName: "", lastName: "", email: ""},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<Profile>) {
      state.profile = action.payload;
    },
    setIsAuth(state, action: PayloadAction<boolean>) {
      state.isAuth = action.payload;
    },
  },
});

export const { setProfile, setIsAuth } = authSlice.actions;
